import React, { FC } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled from 'styled-components';
import FormGroup from 'components/form/FormGroup';
import { useTranslation } from 'react-i18next';
import { IStepFive } from '../types';

interface IProps {
  data: IStepFive;
}

const Notifications: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();
  const { notify_options: notifyOptions, notify: notifyDefaults, can_edit_notify: canEdit } = data;

  return (
    <Row className="mt-5 mb-5">
      <Col sm={6}>
        <h3 className="h5">{t('docWizard.step5.notifyForStatusUpdate')}</h3>
      </Col>
      <Col sm={3}>
        <Row className="d-block pr-3">
          {canEdit && (
            <FormGroup
              controlId="formGroupNotification"
              type="select"
              as="select"
              name="notify"
              isClearable
              isSearchable
              isMulti
              showTotal
              allowSelectAll
              selectOptions={notifyOptions}
              formGroupClassName="mb-0 pl-3"
            />
          )}
          {!canEdit && (
            <>
              {notifyDefaults.map(option => (
                <ListItem>{option.label}</ListItem>
              ))}
            </>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default Notifications;

const ListItem = styled.div`
  padding: 0.5rem 0.75rem;
  border: 1px solid ${props => props.theme.colors.light};
  border-radius: ${props => props.theme.borderRadius};
  margin-bottom: 0.75rem;
`;
